import './theme_black.scss';
import ITheme from '../ITheme';
import NavigationItems from '@/navigationItems';

export default class Themeblack implements ITheme {
    id: string = 'black';
    matchIfHostNameContainsAny: string[] = ['optigo'];
    name: string = 'Rideit';
    cssClassName: string = 'theme_black';
    dark: boolean = false;
    menuDark: boolean = false;
    toolbarDark: boolean = true;
    bottomNavDark: boolean = true;
    menuRight: boolean = false;
    booking: boolean = false;
    menuNavigationItems: INavigationItem[] = [
        NavigationItems.passengers,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.personalInfo,
        NavigationItems.messages,
        NavigationItems.accessibilityReport,
        NavigationItems.privacy,
    ];
    bottomNavNavigationItems: INavigationItem[] = [
        NavigationItems.passengers,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.messages,
    ];
    vuetifyTheme: any = {
        primary: '#000000',
        secondary: '#FFD700',
        accent: 'FFD700',
        warning: 'FFD700',
        error: "#eb1111",
        red: "#e91b0c",
        grey: "#767676",
        bottomNavColor: '#ffffff'
    };
}
